// The Dial lockup: gear-dial mark + etched condensed uppercase wordmark.
// One consistent brand lockup everywhere — no per-skin variants.
export default function Wordmark({ sizeClass = "text-2xl sm:text-3xl", className = "" }) {
  return (
    <span className={`font-head inline-flex items-center gap-2 leading-none ${sizeClass} ${className}`} data-testid="brand-wordmark" aria-label="The Dial">
      <img src="/brand/the-dial-logo-v3-256.png" alt="The Dial" className="h-[1.35em] w-auto flex-none object-contain" data-testid="brand-logo" />
      <span className="inline-flex items-baseline gap-1.5 font-bold uppercase tracking-[0.14em]">
        <span className="text-[var(--text-primary)]">THE</span>
        <span className="text-[#e01b1b]" style={{ textShadow: "0 0 14px rgba(224,27,27,.45)" }}>DIAL</span>
      </span>
    </span>
  );
}
